import React from 'react';
export const en = {
  projectTeam: 'Project Team',
  generalTitle: 'General Settings',
  integrationsTitle: 'Integrations',
  installBugherd: 'Install BugHerd',
  sidebar: 'Sidebar',
  tags: 'Tags',
  commitHook: 'Commit Hook',
  exportBugs: 'Export Bugs',
  disableDelete: 'Disable/delete project',
  advanced: 'Advanced',
  installBugherdTitle: 'Install BugHerd',
  securityTitle: 'Security',
  sidebarSettingsTitle: 'Sidebar Settings',
  editTagsTitle: 'Edit Tags',
  commitTitle: 'Set up a commit hook',
  advancedTitle: 'Advanced Settings',
  disableTitle: 'Disable/Delete project',
  disableCopy:
    "Here you can update your project settings. Please make sure you want to delete your project as you won't be able to retrieve it when it's gone.",
  disableButton: 'Project disabled',
  deleteButton: 'Delete project',
  enableButton: 'Project enabled',
  copy: 'Copy',
  guestPermissions: 'Client Permissions',
  commitIntro:
    'You can configure your Version Control System with a hook and when you reference a BugHerd task, the commit message is added as a comment.',
  commitGit: `Copy and paste the URL below in to your GitHub project under Settings > Webhooks.`,
  commitGitlab: `Copy and paste the URL below in to your GitLab project under Settings > Integrations.`,
  commitBitbucket: `Copy and paste the URL below in to your Bitbucket project under Settings > Integrations > Webhooks.`,
  integrationsDescription:
    'Send tasks from BugHerd to your project management, communications and dev tools.',
  javascriptCodeDescription: [
    `Paste the code in your website's `,
    <code>{`<head>`}</code>,
    ' and Bugherd is ready for you, your client, and team.'
  ],
  javascriptCodeTitle: 'Install the Javascript code',
  javascriptCodeButtonLabel: `Get code`,
  browserExtensionDescription:
    'No code required. Simply add the extension to your browser and BugHerd will appear on your website for you.',
  browserExtensionTitle: 'Get the browser extension',
  browserExtensionButtonLabel: 'Get extension',
  wordpressPluginDescription:
    'The simplest way to install Bugherd on your WordPress site & admin.',
  wordpressPluginTitle: 'Install the WordPress plugin',
  wordpressPluginButtonLabel: 'Install plugin',
  recommended: ' (Recommended)',
  sendInstructions: ' or send instructions to a developer',
  send: 'Send',
  enterEmail: 'Enter email address',
  downloadThe: 'Download the ',
  bugherdWordpressPlugin: 'BugHerd Wordpress Plugin',
  activatePlugin: 'Activate the plugin using this Project Key:',
  copiedToClipboard: (script?: boolean) =>
    `Your project ${
      script ? 'javascript code' : 'key'
    } was successfully copied to the clipboard`,
  deliveredTo: 'Installation instructions will be delivered to ',
  tryAgain: 'Something went wrong, please try again',
  doneThis: `I've done this`,
  installed: 'Installed',
  overrideTitle: 'Use (CMD or CTRL) + Click to unset this',
  updating: 'Updating...',
  updatedProject: (ignore: boolean) =>
    `Validating the existence of the BugHerd javascript in your project sites has now been ${
      ignore ? 'disabled' : 'enabled'
    }.`,
  invalidEmail: 'Please enter a valid email address',
  integrationsGuideHeader: 'Integrating with BugHerd',
  integrationsGuideDescription:
    'See how to integrate BugHerd with your project management, communications and dev tools.',
  bestWorkflow: 'Choosing the right workflow',
  setItUp: 'See our integrations help articles',
  installingBugherd: 'Installing BugHerd',
  installMethod:
    'This guide will help you choose which install method is right for you, your team & clients.',
  clientFeedbackTipsHeader: 'Tips for managing client feedback',
  clientFeedbackTipsDescription:
    'Reduce the time it takes to manage Client feedback with these handy tips.'
};

export type Translations = typeof en;
